import React from 'react';
import i18n from '../../i18n/i18n.js';
import { ReactSVG } from "react-svg";
import PageHeader from "../../components/PageHeader/PageHeader.js";
import Form from '../../components/Forms/Form/Form';

import './ProfileBillAddress.css'; 

class ProfileBillAddress extends React.Component {

  constructor(props) {
    super(props);
    
    this.state = {
      show: false,
      hiding: false,
    };
  }

  /**
   * Form hívja meg ha sikeresen lefutott a handle_submit()
   * ha nincs szükség erre a fv.-re akkor lehet törölni
   */
  on_submit_success(params = {formData: {}, result: {}}) {
    this.hide();
  }

  show() {
    this.setState({show: true});
  }

  hide() {
    this.setState({hiding: true}, function() {
      setTimeout(() => {
        this.setState({show: false, hiding: false});
      }, 200);
    });
  }

  toggle() {
    if (this.state.show)
    {
      this.hide();
    }
    else {
      this.show();
    }
  }

  render() {
    const {formData, formErrors, show, hiding } = this.state;

    if (!show) return '';

    return <div className={`container floating_container page_checkout page_profile_bill_address ${hiding ? 'out' : ''}`}>
          <div className="content">
          
          <PageHeader parent_ref={this} no_close title={i18n.t('profileBillAddressTitle')} />

          <div className='container_inner'>
   
            <Form name="profile_bill" submit_text={i18n.t('save')} parent={this} />

          </div> 
          </div>
      </div>;
  }
}

export default ProfileBillAddress;